<template>
  <div class="home">
    <div class="navigationWap">
      <div class="userWap" v-if="isLogins">
        <div class="userCover">
          <img src="@/assets/images/userLogo.png" />
        </div>
        <div class="userData">
          <div>{{ userInformation.phone }}</div>
        </div>
      </div>

      <div class="userWapNotLogin" v-else>
        未登录
        <!-- <div class="userCover">
          <img src="@/assets/images/userLogo.png">
        </div>
        <div class="userData">
          <div>{{userInformation.phone}}</div>
        </div> -->
      </div>

      <div class="navigation">
        <el-row class="tac">
          <el-col>
            <el-menu class="el-menu-vertical-demo" :default-openeds="listItem">
              <el-sub-menu
                v-for="(item, index) in navList"
                :key="index"
                :index="index + ''"
                unique-opened
              >
                <template #title>
                  <el-icon class="iconStyle">
                    <img :src="item.icon" />
                  </el-icon>
                  <span>{{ item.name }}</span>
                </template>
                <template  v-for="(items, indexs) in item.list">
                  <el-menu-item
                    class="menuItemStyle"
                    :key="indexs"
                    :index="indexs + ''"
                    @click="routerJump(items)"
                    v-if="items.isHidden ? userInformation.companyFlag == 1 ? true : false :  true"
                  >
                    {{ items.name }}
                  </el-menu-item>
                </template>
                <!-- <el-menu-item
                  class="menuItemStyle"
                  v-for="(items, indexs) in item.list"
                  :key="indexs"
                  :index="indexs + ''"
                  @click="routerJump(items)"
                >
                  {{ items.name }}
                </el-menu-item> -->
              </el-sub-menu>
            </el-menu>
          </el-col>
        </el-row>

        <div class="navigationBottom"></div>
      </div>
    </div>

    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "home",
  data() {
    return {
      isLogins: true,
      listItem: ["0", "1", "2", "3", "4"],
      navList: [
        {
          name: "主页",
          icon: require("@/assets/images/homeIcon1.png"),
          list: [
            {
              name: "主页",
              linkUrl: "homeStartingPage",
            },
          ],
        },
        {
          name: "个人中心",
          icon: require("@/assets/images/homeIcon8.png"),
          list: [
            {
              name: "账号管理",
              linkUrl: "accountManagement",
            },
            {
              name: "账号认证",
              linkUrl: "accountSettings",
            },
          ],
        },
        {
          name: "文章",
          icon: require("@/assets/images/homeIcon2.png"),
          list: [
            {
              name: "内容上链",
              linkUrl: "contentChain",
            },
            {
              name: "版权确权导入",
              linkUrl: "copyrightExport",
              isHidden: true
            },
            {
              name: "文章管理",
              linkUrl: "homeArticleManagement",
            },
          ],
        },
        {
          name: "运营管理",
          icon: require("@/assets/images/homeIcon6.png"),
          list: [
            {
              name: "文章订单",
              linkUrl: "orderManagement",
            },
          ],
        },
        {
          name: "资产管理",
          icon: require("@/assets/images/homeIcon4.png"),
          list: [
            {
              name: "提现管理",
              linkUrl: "cashManagement",
            },
            {
              name: "发票管理",
              linkUrl: "invoiceManagement",
            },
          ],
        },
        // {
        //   name: "管理",
        //   icon: require("@/assets/images/homeIcon4.png"),
        //   list: [
        //     {
        //       name: "作者管理",
        //       linkUrl: "homeStartingPage",
        //     },
        //   ],
        // },
        // {
        //   name: "设置",
        //   icon: require("@/assets/images/homeIcon5.png"),
        //   list: [
        //     {
        //       name: "设置",
        //       linkUrl: "homeStartingPage",
        //     },
        //   ],
        // }
      ],
      userInformation: "",
    };
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  watch: {
    isLogin(value) {
      this.isLogins = value;
    },
  },
  components: {},
  methods: {
    routerJump(e) {
      this.$router.push(e.linkUrl);
    },
  },
  mounted() {
    this.userInformation = JSON.parse(Cookies.get("userInformation")) || "";
  },
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f5f5f5");
  },
  beforeUnmount() {
    document.querySelector("body").removeAttribute("style");
  },
};
</script>
<style lang="scss">
.home {
  .el-sub-menu__title {
    padding: 0;
    line-height: inherit !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
    font-size: 15px;
    font-family: AlibabaPuHuiTiM;
    color: #606266;
  }
}
</style>
<style lang="scss" scope>
.home {
  width: 1324px;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
  .container {
    width: 1050px;
  }
  .navigationWap {
    width: 250px;
    border-radius: 12px;
    overflow: hidden;
    // margin-right: 16px;
    .navigation {
      width: 100%;
      .menuItemStyle {
        padding-left: 68px !important;
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #606266;
      }
      .iconStyle {
        width: 24px;
        height: auto;
        margin-right: 8px;
        font-size: 0;
        img {
          width: 100%;
        }
      }
    }
    .userWapNotLogin {
      width: 100%;
      height: 108px;
      background: #e3f3fc;
      font-size: 18px;
      color: #303133;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .userWap {
      width: 100%;
      height: 108px;
      background: #e3f3fc;
      padding: 30px 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .userData {
        width: 128px;
        margin-left: 10px;
        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-family: AlibabaPuHuiTiB;
        }
        div:nth-of-type(1) {
          font-size: 18px;
          color: #303133;
        }
        div:nth-of-type(2) {
          font-size: 13px;
          color: #909399;
        }
      }
      .userCover {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        flex-shrink: 0;
        img {
          width: 100%;
        }
      }
    }
    .navigationBottom {
      padding: 72px 22px 26px 22px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #fff;
      div:nth-of-type(1) {
        font-size: 12px;
        font-family: AlibabaPuHuiTiM;
        color: #606266;
      }
      div:nth-of-type(2) {
        width: 72px;
        height: 28px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #303133;
        font-size: 13px;
        font-family: AlibabaPuHuiTiM;
        color: #303133;
        line-height: 28px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>
